.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 10px;
  border-radius: var(--radius-pill);
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: 1px solid transparent;
  white-space: nowrap;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 8px currentColor;
}

.pulse .dot {
  animation: spoyl-pulse 1.8s var(--ease-out) infinite;
}

.brand {
  color: var(--brand-400);
  background: rgba(139, 92, 246, 0.14);
  border-color: rgba(139, 92, 246, 0.28);
}

.success {
  color: var(--status-success);
  background: rgba(52, 211, 153, 0.13);
  border-color: rgba(52, 211, 153, 0.26);
}

.warning {
  color: var(--status-warning);
  background: rgba(251, 191, 36, 0.13);
  border-color: rgba(251, 191, 36, 0.26);
}

.danger {
  color: var(--status-danger);
  background: rgba(244, 63, 94, 0.13);
  border-color: rgba(244, 63, 94, 0.26);
}

.neutral {
  color: var(--text-muted);
  background: var(--surface-2);
  border-color: var(--border-subtle);
}
